module.exports = __webpack_public_path__ + "img/sensor-disconnected.37eb87a3.png";